<template>
    <div id="editDealSWOT">
      <pt-modal :title="$t('deal.dealDetails.dealDetail.SWOTLabel')" :visible="visible" :width="800"
                @cancel="hide" @ok="submit">
        <div slot="content">
          <div class="swot">
            <a-form :form="form">
              <a-form-item v-show="false">
                <pt-input v-decorator="['id',{}]" ></pt-input>
              </a-form-item>
              <a-row>
                <a-form-item :label="$t('deal.dealDetails.SWOT.strength')" class="required">
                  <pt-input v-decorator="decorators.strength" type="textarea" :autosize="{minRows:3,maxRows:3}" class="input"
                  :placeholder="$t('deal.dealDetails.SWOT.placeholder.strength')"></pt-input>
                </a-form-item>
              </a-row>
              <a-row>
                <a-form-item :label="$t('deal.dealDetails.SWOT.weakness')" class="required">
                  <pt-input v-decorator="decorators.weakness" type="textarea" :autosize="{minRows:3,maxRows:3}" class="input"
                            :placeholder="$t('deal.dealDetails.SWOT.placeholder.weakness')"></pt-input>
                </a-form-item>
              </a-row>
              <a-row>
                <a-form-item :label="$t('deal.dealDetails.SWOT.opportunity')" class="required">
                  <pt-input v-decorator="decorators.opportunity" type="textarea" :autosize="{minRows:3,maxRows:3}" class="input"
                            :placeholder="$t('deal.dealDetails.SWOT.placeholder.opportunity')"></pt-input>
                </a-form-item>
              </a-row>
              <a-row>
                <a-form-item :label="$t('deal.dealDetails.SWOT.threats')" class="required">
                  <pt-input v-decorator="decorators.threats" type="textarea" :autosize="{minRows:3,maxRows:3}" class="input"
                            :placeholder="$t('deal.dealDetails.SWOT.placeholder.threats')"></pt-input>
                </a-form-item>
              </a-row>
            </a-form>
          </div>
        </div>
      </pt-modal>
    </div>
</template>

<script>
  import dealSWOTApi from '@/api/mine/dealSWOT'

  export default {
    name: 'editDealSWOT',
    props:{
      visible:{
        type: Boolean,
        default: false
      },
      dealId:{
        type: String,
        default: null
      }
    },
    data(){
      return {
        form: this.$form.createForm(this,{}),
        decorators:{
          strength:['strength',{rules:[{required:true,message:this.$t('deal.dealDetails.SWOT.errorInfo.strength')}],initialValue:null}],
          weakness:['weakness',{rules:[{required:true,message:this.$t('deal.dealDetails.SWOT.errorInfo.weakness')}],initialValue:null}],
          opportunity:['opportunity',{rules:[{required:true,message:this.$t('deal.dealDetails.SWOT.errorInfo.opportunity')}],initialValue:null}],
          threats:['threats',{rules:[{required:true,message:this.$t('deal.dealDetails.SWOT.errorInfo.threats')}],initialValue:null}],
        },
        dealSwotDO:null,
      }
    },
    methods:{
      hide(){
        this.$emit('hide')
      },
      selectByDealId(){
        let this_ = this
        dealSWOTApi.selectByDealId(this.dealId).then(res=>{
          if(res.code == 1){
            let dealSWOT = res.data
            if(res.data){
              this_.dealSwotDO = res.data
              this_.form.setFieldsValue(dealSWOT)
            }
          }else{

          }
        })
      },
      submit(){
        let swotDO = {}
        this.form.validateFieldsAndScroll((err, values) => {
          if (!err) {
            Object.assign(swotDO,this.form.getFieldsValue())
            swotDO.dealId = this.dealId
            dealSWOTApi.insert(swotDO).then(res=>{
              if(res.code == 1){
                this.$message.success(res.message)
                this.$emit('saveSuccess')
              }else{
                this.$message.error(res.message)
              }
            })
          } else {

          }
        })
      },
    },
    watch:{
      visible(){
        if(this.visible){
          this.selectByDealId()
        }
      }
    }
  }
</script>

<style scoped lang="less">
  .swot{
    padding: 25px 20px;
    background: rgba(248,249,251,0.62);
    border-radius: 0 0 4px 4px;
  }
  .input{
    background-color: #ffffff;
  }
</style>